import { Contracts } from '../types';

// TODO(arbitrum-sepolia): fill in the testnet deployment addresses.
// Unlike other networks these are not yet available as an
// `@/assets/data/contracts/arbitrum-sepolia.json` file, so they are inlined
// here. `multicall` is the canonical Multicall3 address, which is deployed at
// the same address on Arbitrum Sepolia as on every other chain.
const contracts: Contracts = {
  merkleRedeem: '',
  merkleOrchard: '',
  multicall: '0xca11bde05977b3631167028862be2a173976ca11',
  authorizer: '',
  vault: '',
  weightedPoolFactory: '',
  stablePoolFactory: '',
  lidoRelayer: '',
  balancerHelpers: '',
  batchRelayer: '',
  gaugeFactory: '',
  balancerMinter: '',
  gaugeController: '',
  tokenAdmin: '',
  veBAL: '',
  veDelegationProxy: '',
  veBALHelpers: '',
  feeDistributor: '',
  feeDistributorDeprecated: '',
  faucet: '',
  gaugeRewardsHelper: '',
};

export default contracts;
